module.exports = __webpack_public_path__ + "WISE_Logo-b9d02c3bc210a142c9c6687483879b6b.png";